import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import InfoTipModel from '../info-tip.model';

@Component(
	{ exportAs: 'dag-info-tip-wrapper'
	, templateUrl: './info-tip-wrapper.component.html'
	, styleUrls: [ './info-tip-wrapper.component.css' ]
	}
)
export class InfoTipWrapperComponent {
	@Input() public info$: Observable<InfoTipModel>;
	@Input() public elseLabel: string;
	@Input() public showIcon: boolean;
}
